var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7279 2.24271C12.831 4.34576 13.0465 7.6216 11.3744 9.96499C11.3952 9.98264 11.4154 10.0013 11.435 10.0209L14.2635 12.8493C14.654 13.2398 14.654 13.873 14.2635 14.2635C13.8729 14.6541 13.2398 14.654 12.8492 14.2635L10.0208 11.4351C10.0012 11.4155 9.98257 11.3952 9.96492 11.3745C7.62153 13.0465 4.34569 12.831 2.24264 10.728C-0.100505 8.38485 -0.100505 4.58586 2.24264 2.24271C4.58579 -0.100435 8.38478 -0.100435 10.7279 2.24271ZM9.31389 9.31378C10.876 7.75168 10.876 5.21902 9.31389 3.65692C7.7518 2.09483 5.21914 2.09483 3.65704 3.65692C2.09494 5.21902 2.09494 7.75168 3.65704 9.31378C5.21914 10.8759 7.7518 10.8759 9.31389 9.31378Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0fd36b53.svg";
export { ForwardRef as ReactComponent };